var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"contact-btn",attrs:{"target":"_blank","href":"https://regimenpro.com/pages/contact-us"}},[_vm._v("Contact Us")])
}
var staticRenderFns = []

export { render, staticRenderFns }